import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { cn } from 'utils/cn';

export function RichEditorKeyboardHintItems() {
  return (
    <>
      <p>
        <strong>Tab:</strong> em parágrafos, adiciona recuo no texto; em listas, aninha o item
        atual (sublista).
      </p>
      <p>
        <strong>Shift+Tab:</strong> remove o recuo do parágrafo ou sobe o item para o nível
        anterior da lista.
      </p>
      <p>
        <strong>Listas numeradas:</strong> use o botão na barra de ferramentas ou digite{' '}
        <code className="rounded bg-muted px-1 py-0.5 text-xs font-mono">1.</code> seguido de
        espaço. Pressione <strong>Enter</strong> para um novo item e <strong>Tab</strong> para
        aninhar — 1, 2, 3 no primeiro nível; a, b, c no segundo; i, ii, iii no terceiro.
      </p>
      <p>
        <strong>Listas com marcadores:</strong> use o botão na barra; <strong>Tab</strong> e{' '}
        <strong>Shift+Tab</strong> funcionam da mesma forma para aninhar ou desaninhar itens.
      </p>
    </>
  );
}

const RichEditorInstructionsPanel = ({
  title = 'Atalhos do editor',
  showToggleLabel = 'Mostrar Atalhos',
  hideToggleLabel = 'Ocultar atalhos',
  showInnerTitle = true,
  children,
  className,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={cn(
        'mb-4 rounded-lg border border-border bg-muted/30 overflow-hidden',
        className
      )}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm font-medium text-foreground hover:bg-muted/50 transition-colors"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        {open ? hideToggleLabel : showToggleLabel}
        <Icon
          name={open ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          className="text-muted-foreground shrink-0"
        />
      </button>
      {open ? (
        <div className="space-y-2 border-t border-border/60 px-4 pb-4 pt-3 text-sm text-foreground">
          {showInnerTitle && title ? (
            <p className="font-medium text-foreground">{title}</p>
          ) : null}
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default RichEditorInstructionsPanel;
